<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md8
      >
        <material-card
          :color="color"
          title="Profile"
        >
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user.name"
                    class="purple-input"
                    label="Name"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user.email"
                    label="Email Address"
                    class="purple-input"
                    disabled
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
        <material-card
          :color="color"
          title="Change Password"
        >
          <v-form v-model="changePasswordValid">
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    ref="changePassword.current_password"
                    v-model="changePassword.current_password"
                    :rules="[rules.required]"
                    type="password"
                    class="purple-input"
                    label="Current Password"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    ref="changePassword.password"
                    v-model="changePassword.password"
                    :rules="[rules.required, rules.min8chars]"
                    type="password"
                    label="New Password"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    ref="changePassword.password_confirmation"
                    v-model="changePassword.password_confirmation"
                    :rules="[rules.required, rules.min8chars, passwordConfirmationRule]"
                    type="password"
                    label="New Password Confirmation"
                    class="purple-input"
                  />
                </v-flex>
              </v-layout>
              <v-btn
                :color="color"
                align-center
                justify-center
                @click="updatePassword">Change Password
              </v-btn>
              &nbsp;
              <p style="color:red; display:inline">{{ changePasswordError }}</p>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        xs12
        md4
      >
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130"
          >
            <img
              src="https://bookingagentinfo.com/wp-content/uploads/2014/12/Travis-Scott-Contact-Information.jpg"
            >
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-thin mb-3">Back Office Team</h6>
            <h4 class="card-title font-weight-light">Blah Blah Blah</h4>
            <p class="card-description font-weight-light">At Blah Blah Blah, we design exquisite websites with unlimited features, functionalities, and SEO optimized. What will high Google ranking do for your company? Imagine your new website on the first page of search engines.</p>
          </v-card-text>
        </material-card>
      </v-flex>
      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-btn
          flat
          @click="snack = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'

  export default {
  data: function () {
    return {
      user: JSON.parse(localStorage.getItem('userInfo')),
      changePassword: {
        password: '',
        password_confirmation: '',
        current_password: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        min8chars: v => v.length >= 8 || 'Minimum 8 characters!'
      },
      changePasswordError: '',
      snack: false,
      snackColor: '',
      snackText: '',
      changePasswordValid: false
    }
  },
    computed: {
      ...mapState('app', ['color']),
      passwordConfirmationRule () {
        return () => (this.changePassword.password === this.changePasword.password_confirmation) || 'Password must match'
      }
    },
    methods: {
      updatePassword () {
        if (!(this.changePasswordValid)) {
            this.snackText = 'Fill out current password and nwe password.'
          this.snackColor = 'error'
          this.snack = true
          return
        }
        this.changePasswordError = ''
        this.$store.state.spinning = true
        axios.put('/user/password/', this.changePassword)
                .then((response) => {
                  this.snackText = 'Password Updated successfully!'
                  this.snackColor = 'success'
                  this.snack = true
                  this.$store.state.spinning = false
                  }
                )
                .catch(error => {
                  if (error.response.status == '422') {
                    this.snackText = JSON.stringify(error.response.data.errors)
                    this.snackColor = 'error'
                    this.snack = true
                  } else {
                    this.snackText = 'Something went wrong, please try again later.'
                    this.snackColor = 'error'
                    this.snack = true
                  }
                  this.$store.state.spinning = false
                })
        console.log('updating password')
      }
    }
}
</script>
